/*
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" * / './views/About.vue')
    }
  ]
})
*/

import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/views/Homepage'
import Cart from '@/views/Cart'
import ProductArticles from '@/views/ProductArticles'
import ProductTypes from '@/views/ProductTypes'
import NewProduct from '@/views/NewProduct'
import NewProductOrigine from '@/views/NewProductOrigine'
import NewProductParameter from '@/views/NewProductParameter'
import NewProductDestinazione from '@/views/NewProductDestinazione'
import NewProductPassaggio from '@/views/NewProductPassaggio'
import NewProductEnd from '@/views/NewProductEnd'
import MyTickets from '@/views/MyTickets'
import MyTicket from '@/views/MyTicket'
import Account from '@/views/Account'
import CscContractsPage from '@/views/CscContractsPage.vue'
import AnagraficaPage from '@/views/AnagraficaPage'
import StoricoAcquistiPage from '@/views/StoricoAcquistiPage'
import Settings from '@/views/Settings'
import Help from '@/views/Help'
import StopCalls from '@/views/StopCalls'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Register2 from '@/views/Register2'
import PasswordRecovery from '@/views/PasswordRecovery'
import PasswordRecoveryEnd from '@/views/PasswordRecoveryEnd'
import PasswordChange from '@/views/PasswordChange'
import CSCSelector from '@/views/CSCSelector'
import Addresses from '@/views/Addresses'
import AddressPage from '@/views/AddressPage'
import TripPlannerPage from '@/views/TripPlannerPage'
import FakePaymentPage from '@/views/FakePaymentPage'
import EndPaymentPage from '@/views/EndPaymentPage'
import store from './store'
import internalBus from '@/internalBus'
import ExtraMobilePage from '@/views/ExtraMobilePage'
import WrongCartType from '@/views/WrongCartType'
import RelativeUsersPage from '@/views/RelativeUsersPage'
import CompleteRelativeUser from '@/views/CompleteRelativeUser'
// import PageSelectSync from '@/views/PageSelectSync'
// import storeManifest from '@/storeManifest'

Vue.use(Router)

let firstTry = true

let connectionRequired = (to, from, next) => {
  // console.log('connectionRequired', store.state.connectionStatus, from, to)
  if(firstTry || store.state.connectionStatus === 'online') {
    firstTry = false
    next()
  } else {
    internalBus.$emit('notify:error', {
      text: 'Connessione assente',
      timeout: 3000
    })
  }
}

/* let loginAtLeastAnonymousRequired = (from, to, next) => {
  window.VUEAPP.$http.post('auth/anonymous', {}, window.VUEAPP.completeHttpParams({})).then(response => response.body).then(response => {
    window.VUEAPP.$set(window.VUEAPP, 'user', response)
    next()
  })
} */

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/updateemail',
      name: 'Homepage_ConfirmMailChange',
      component: Homepage
    }, /* {
      path: '/registrationend',
      name: 'HomepageRegistrationEnd',
      component: Homepage
    }, */ 
    {
      path: '/registrationend',
      name: 'RegistrationEnd',
      component: Register2
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/cart/:close?',
      name: 'Cart',
      component: Cart,
      beforeEnter: connectionRequired
    },
    {
      path: '/wrongcarttype/:type',
      name: 'WrongCartType',
      component: WrongCartType
    },
    {
      path: '/products/:type/:productId/:articleId/end',
      name: 'NewProductEnd',
      component: NewProductEnd,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/products/:type/:productId/:articleId/:what',
      name: 'NewProductParameter',
      component: NewProductParameter,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/products/:type/:productId/:articleId/origins',
      name: 'NewProductOrigine',
      component: NewProductOrigine,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/products/:type/:productId/:articleId/travels',
      name: 'NewProductDestinazione',
      component: NewProductDestinazione,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/products/:type/:productId/:articleId/t',
      name: 'NewProductPassaggio',
      component: NewProductPassaggio,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/cscselector',
      name: 'CSCSelector',
      component: CSCSelector
    },
    {
      path: '/products/:type/:productId',
      name: 'ProductArticles',
      component: ProductArticles,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/products/:type/:productId/:articleId',
      name: 'NewProduct',
      component: NewProduct,
      props: true,
      beforeEnter: connectionRequired
    },
    {
      path: '/producttypes',
      name: 'ProductTypes',
      component: ProductTypes,
      beforeEnter: connectionRequired
    },
    {
      path: '/account/anagrafica/:onlyread',
      name: 'AnagraficaPage',
      component: AnagraficaPage,
      props: true,
    },
  
    {
      path: '/account/addresses',
      name: 'Addresses',
      component: Addresses
      
    },
    {
      path: '/account/addresses/:idx',
      name: 'AddressPage',
      component: AddressPage,
      props: true
    },
    {
      path: '/account/purchases',
      name: 'StoricoAcquistiPage',
      component: StoricoAcquistiPage
    },
    {
      path: '/account/RELATIVEusers',
      name: 'RelativeUsersPage',
      component: RelativeUsersPage
    },

    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/account/csc/:id',
      name: 'CscContractsPage',
      component: CscContractsPage,
      props: true
    },
    {
      path: '/mytickets/:myTicketId',
      name: 'MyTicket',
      component: MyTicket,
      props: true
    },
    {
      path: '/mytickets',
      name: 'MyTickets',
      component: MyTickets
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/stopcalls',
      name: 'Stop Calls',
      component: StopCalls,
      beforeEnter: connectionRequired
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      beforeEnter: connectionRequired
    },
    {
      path: '/register2',
      name: 'Register2',
      component: Register2,
      beforeEnter: connectionRequired
    },
    {
      path: '/passwordrecovery',
      name: 'Password recovery',
      component: PasswordRecovery,
      beforeEnter: connectionRequired
    },
    {
      path: '/passwordrecoveryend',
      name: 'Password recovery END',
      component: PasswordRecoveryEnd
    }, {
      path: '/changepassword',
      name: 'Change password',
      component: PasswordChange,
      beforeEnter: connectionRequired
    }, {
      path: '/tripplanner',
      name: 'Trip planner',
      component: TripPlannerPage,
      beforeEnter: connectionRequired
    }, {
      path: '/fakepayment',
      name: 'Fake payment',
      component: FakePaymentPage
    }, {
      path: '/endpayment',
      name: 'End payment',
      component: EndPaymentPage
    }, {
      path: '/extramobilepage',
      name: 'Extra mobile page',
      component: ExtraMobilePage
    },
    {
      path: '/confirmlink',
      name: 'RelativeUserEnd',
      component: CompleteRelativeUser
    }
    
  ]
})
